<template>
    <div class="input"
         v-bind:class="{'input--invalid': error, 'focused': focused, 'filled': !(null === value || '' === value)}">
        <label v-if="label" :for="inputId">{{ label }}</label>
        <input :type="type" ref="input" :value.trim="value" :name="name" :placeholder="placeholder" @input="onUpdate"
               @change="onChange" @blur="onBlur" @focus="onFocus" :disabled="disabled" :id="inputId" :class="lengthType"
               :tabindex="tabindex" :autofocus="autofocus" :min="min" :max="max"/>
        <div class="suffix" v-if="suffix">
            <span v-html="suffix"/>
        </div>
        <input-error v-if="v" :v="v" :name="name" @o3-error="error = $event"/>
    </div>
</template>

<script>

import InputMixin from './mixin';

export default {
    name:   'FormInput',
    mixins: [InputMixin],
    props:  {
        min: {
            type:     Number,
            required: false,
            default:  () => null,
        },
        max: {
            type:     Number,
            required: false,
            default:  () => null,
        }
    }
}
</script>
